import React from "react";

export default class TncTrial extends React.Component{
  render(){
    return (
      <div className="row padding-10">
        <div className="col-sm-12 terms-cond">
          <div>
            {
              this.props.conditionalTC === true &&
              <span className="text-uppercase">{this.props.headline} - </span>
            }
            TERMS & CONDITIONS</div>
          <ul className="list-padding">
            <li>I warrant I am authorised to enter this contract on behalf of the business;</li>
            <li>I agree to be bound by this contract with RP Data Pty Ltd t/a Cotality ; and</li>
            <li>I acknowledge this contract comprises of:
              <ul>
                <li>Commercial terms on this page;</li>
                <li><a className="terms-link" href="https://www.cotality.com/au/legal/terms-conditions" target="_blank" rel="noopener noreferrer">Cotality Licence Agreement</a>; and</li>
                <li><a className="terms-link" href="https://www.cotality.com/au/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>; and</li>
              </ul>
            </li>
            <li>I understand this is a trial which will automatically expire after 7 days.</li>
          </ul>
        </div>
      </div>
    )
  }
}
